import type { ApiBillingAddress } from '#/api/types/ApiBillingAddress';
import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  billingAddresses: ApiBillingAddress[];
};

function mapResponse(response: ApiResponse) {
  return response.billingAddresses;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId) =>
    `/data/orgdashboard/${orgId}/billing-addresses`,
  mapResponse,
});

// Exports

export const useOrgDashboardApiFetchBillingAddresses =
  endpoint.createUseFetchHook();

export const orgDashboardApiIsomorphicFetchBillingAddresses =
  endpoint.createIsomorphicFetchFn();
